/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Insert_SpeakerInputs */

const en_shortcut_keys_name_insert_speaker = /** @type {(inputs: Shortcut_Keys_Name_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert Speaker`)
};

const fr_shortcut_keys_name_insert_speaker = /** @type {(inputs: Shortcut_Keys_Name_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer un locuteur`)
};

const de_shortcut_keys_name_insert_speaker = /** @type {(inputs: Shortcut_Keys_Name_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautsprecher einbauen`)
};

const it_shortcut_keys_name_insert_speaker = /** @type {(inputs: Shortcut_Keys_Name_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci altoparlante`)
};

const ru_shortcut_keys_name_insert_speaker = /** @type {(inputs: Shortcut_Keys_Name_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить динамик`)
};

const es_shortcut_keys_name_insert_speaker = /** @type {(inputs: Shortcut_Keys_Name_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar altavoz`)
};

const zh_cn2_shortcut_keys_name_insert_speaker = /** @type {(inputs: Shortcut_Keys_Name_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入扬声器`)
};

const ja_shortcut_keys_name_insert_speaker = /** @type {(inputs: Shortcut_Keys_Name_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーを挿入`)
};

const hi_shortcut_keys_name_insert_speaker = /** @type {(inputs: Shortcut_Keys_Name_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर डालें`)
};

const pt_pt2_shortcut_keys_name_insert_speaker = /** @type {(inputs: Shortcut_Keys_Name_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto-falante de inserção`)
};

/**
* | output |
* | --- |
* | "Insert Speaker" |
*
* @param {Shortcut_Keys_Name_Insert_SpeakerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_insert_speaker = /** @type {((inputs?: Shortcut_Keys_Name_Insert_SpeakerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Insert_SpeakerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_insert_speaker(inputs)
	if (locale === "de") return de_shortcut_keys_name_insert_speaker(inputs)
	if (locale === "it") return it_shortcut_keys_name_insert_speaker(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_insert_speaker(inputs)
	if (locale === "es") return es_shortcut_keys_name_insert_speaker(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_insert_speaker(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_insert_speaker(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_insert_speaker(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_insert_speaker(inputs)
	return en_shortcut_keys_name_insert_speaker(inputs)
});